module.exports = __webpack_public_path__ + "static/media/the-victorian-internet.c695cd93.jpg";